// Pure helpers for the admin "Anahtar kelimeler" page (Turkish UI).
export const MAX_KEYWORDS = 5;
export const SLUG_RE = /^[a-z0-9][a-z0-9-]{1,39}$/;

export const AUTO_HINT = "otomatik seçim — düzenlemek için elle kaydet (elle kayıt otomatik olanı geçersiz kılar)";

const norm = (s) => String(s).trim().toLowerCase().replace(/\s+/g, " ");

// "a\nb, c" -> ["a","b","c"] (trimmed, empties dropped, original case kept)
export function splitList(text) {
  return String(text || "").split(/[\n,]+/).map((s) => s.trim()).filter(Boolean);
}

// Mirrors the backend PUT validation. Returns a list of Turkish error strings.
export function validateKeywordSet({ slug, name, match_terms, keywords }) {
  const errs = [];
  if (!SLUG_RE.test(String(slug || ""))) errs.push("Kısa ad (slug) 2-40 karakter olmalı: küçük harf, rakam ve tire; harf/rakamla başlamalı.");
  if (!String(name || "").trim()) errs.push("Ad boş olamaz.");
  const kws = keywords || [];
  if (kws.length < 1) errs.push("En az 1 anahtar kelime gerekli.");
  if (kws.length > MAX_KEYWORDS) errs.push(`En fazla ${MAX_KEYWORDS} anahtar kelime olabilir.`);
  if (kws.some((k) => String(k).trim().length < 2 || String(k).trim().length > 60)) errs.push("Her anahtar kelime 2-60 karakter olmalı.");
  if (new Set(kws.map(norm)).size !== kws.length) errs.push("Anahtar kelimeler tekrar edemez.");
  const mt = match_terms || [];
  if (new Set(mt.map(norm)).size !== mt.length) errs.push("Eşleşme terimleri tekrar edemez.");
  return errs;
}

export function setPayload({ name, match_terms, keywords }) {
  return { name: String(name).trim(), match_terms: match_terms.map((s) => s.trim()), keywords: keywords.map((s) => s.trim()) };
}

export const sourceLabel = (set) => {
  const s = set && set.source;
  if (s === "auto") return "otomatik";
  if (set && set.slug === "kfz-gutachter" && s !== "auto") return s === "manual" ? "elle" : "varsayılan";
  return "elle";
};

const fmt = (n) => new Intl.NumberFormat("tr-TR").format(n);

// One keyword with volume + trend, only what the stats carry.
export function keywordStatText(set, keyword) {
  const st = Array.isArray(set.keyword_stats) ? set.keyword_stats.find((x) => x.keyword === keyword) : null;
  if (!st || typeof st.monthly_searches !== "number") return keyword;
  let out = `${keyword} — ${fmt(st.monthly_searches)}/ay`;
  if (typeof st.trend_pct === "number") out += ` (${st.trend_pct > 0 ? "+" : ""}${String(st.trend_pct).replace(".", ",")}%)`;
  return out;
}

export function formatDate(iso) {
  const t = Date.parse(iso || "");
  return Number.isFinite(t) ? new Date(t).toLocaleString("tr-TR") : "-";
}

// Turkish message for a failed discover call.
export function discoverErrorText(err) {
  const status = err && err.response && err.response.status;
  if (status === 409) return "Günlük anahtar kelime limiti doldu; yarın tekrar deneyin.";
  if (status === 422) return "Geçersiz istek: sektör kelimesini kontrol edin ve onayı verin.";
  if (status === 502) return "Veri sağlayıcı (DataForSEO) hata verdi; birazdan tekrar deneyin. Ücret yazılmadı.";
  return "Sektör kelimeleri bulunamadı.";
}

export function discoverPlanText(plan, formatUsd) {
  if (!plan) return "";
  return plan.cached
    ? "Bu kelime için sonuç önbellekte: yeni harcama yok ($0,00)."
    : `Önbellekte yok: tahmini ${formatUsd(plan.estimated_usd)} gerçek para harcanacak.`;
}
